import { render, staticRenderFns } from "./SelectExchangeProduct.vue?vue&type=template&id=71c4084c&scoped=true&"
import script from "./SelectExchangeProduct.vue?vue&type=script&lang=js&"
export * from "./SelectExchangeProduct.vue?vue&type=script&lang=js&"
import style0 from "./SelectExchangeProduct.vue?vue&type=style&index=0&id=71c4084c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c4084c",
  null
  
)

export default component.exports